// @ts-strict

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BaseApiResponse } from '../../models/core-models';
import { IPrivateChatData, IPrivateChatUser, IPrivateChatUsersList, IPrivateMessage } from '@app/types/private-chat';
import { IChatUser, PageableApiResponse } from '../..';
import { MessageData } from '../general-chat/general-chat.service.types';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrivateChatService {
  public currentlyChattingWith = '';
  public userActive = false;
  public modalToMaximized = false; // dont nullify currentActiveChat on destroy
  public newMessageCounter = new Subject<void>();
  public currentuserID?: number;
  public fullviewActiveChatObser = new BehaviorSubject<(IPrivateChatUser & { message_id?: number }) | null>(null);
  public unreadMessages$ = new BehaviorSubject<null | number>(null);
  public fetchData = new Subject<boolean>();
  public privateChatData$ = new BehaviorSubject<BaseApiResponse<IPrivateChatUsersList> | undefined>(undefined);
  private privateChatActive = new BehaviorSubject<{ status: boolean; userType: string }>({ status: false, userType: 'user' });
  public currentActiveChat = new BehaviorSubject<IChatUser | null>(null);
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  public privateChatActiveObser = this.privateChatActive.asObservable();
  public currentActiveChatObser = this.currentActiveChat.asObservable();

  constructor(private readonly http: HttpClient) {}

  public togglePrivateChat({ status, userType }: { status: boolean; userType: string }): void {
    this.privateChatActive.next({ status, userType });
  }

  public sentCurrentChat(currentChatData: IChatUser): void {
    this.currentActiveChat.next(currentChatData);
  }

  public getPrivateChatUsersList(): Observable<BaseApiResponse<IPrivateChatUsersList>> {
    return this.http.get<BaseApiResponse<IPrivateChatUsersList>>(environment.apiUrl + `/private_chat/users`, this.httpOptions).pipe(
      tap(res => {
        this.privateChatData$.next(res);
        if (res.data) {
          // leaving this as im not sure if it will work
          // res.data.users = [
          //   {
          //     "user_id": 346,
          //     "username": "my.ref",
          //     "avatar": "https://static.mylead.global/img/mobileapp/chat/logo-ml-chat-black.png",
          //     "online": false,
          //     "content": "Chy gcxd hjhfd hhh",
          //     "shown": false,
          //     "created_at": "2024-10-17T14:04:17.000000Z",
          //     "unread": 0
          //   },
          //   {
          //     "user_id": 4,
          //     "username": "DawidSk",
          //     "avatar": "https://static.mylead.global/img/users/avatars/41700851796.png",
          //     "online": false,
          //     "content": "i co, plumka ?",
          //     "shown": false,
          //     "created_at": "2024-07-17T12:28:22.000000Z",
          //     "unread": 0
          //   },
          //   {
          //     "user_id": 22,
          //     "username": "Timbo",
          //     "avatar": "https://static.mylead.global/img/users/avatars/78271684158406.png",
          //     "online": false,
          //     "content": "123",
          //     "shown": false,
          //     "created_at": "2024-05-21T10:29:14.000000Z",
          //     "unread": 0
          //   },
          //   {
          //     "user_id": 69,
          //     "username": "ITMylead",
          //     "avatar": "https://static.mylead.global/img/mobileapp/chat/logo-ml-chat-black.png",
          //     "online": false,
          //     "content": "ale defaultową z apki mobilnej",
          //     "shown": false,
          //     "created_at": "2024-05-14T08:04:50.000000Z",
          //     "unread": 0
          //   }
          // ];
          this.countUnreadMessages(res.data);
        }
      })
    );
  }

  public markAsRead(messageData: IPrivateChatUser, sectionName: keyof IPrivateChatUsersList) {
    const user = (this.privateChatData$.value?.data?.[sectionName] || []).find(user => user.user_id === messageData.user_id);
    if (user && this.privateChatData$.value?.data) {
      this.privateChatData$.value?.data?.[sectionName]?.map(user => {
        if (user.user_id === messageData.user_id) {
          user.unread = 0;
        }
      });
      this.countUnreadMessages(this.privateChatData$.value?.data);
    }
  }

  public countUnreadMessages(data: IPrivateChatUsersList): void {
    let counter = 0;
    data.users?.map(item => {
      if (item.unread) {
        counter = counter + item.unread;
      }
    });
    data.support?.map(item => {
      if (item.unread) {
        counter = counter + item.unread;
      }
    });
    this.unreadMessages$.next(counter);
  }

  public getPrivateChatMessages(targetID: number, page: number): Observable<PageableApiResponse<IPrivateChatData>> {
    return this.http.get<PageableApiResponse<IPrivateChatData>>(environment.apiUrl + `/private_chat/${targetID}/messages?page=${page}`, this.httpOptions);
  }

  public sendPrivateChatMessage({ command, message }: MessageData, target_id: number): Observable<BaseApiResponse<IPrivateMessage>> {
    if (message) {
      return this.http.post<BaseApiResponse<IPrivateMessage>>(environment.apiUrl + '/private_chat/store', { message, target_id }, this.httpOptions);
    } else {
      return this.http.post<BaseApiResponse<IPrivateMessage>>(environment.apiUrl + '/private_chat/store', { command, target_id }, this.httpOptions);
    }
  }
}
